import axios from 'axios';

const WC_ID = 'cdkedkk4s26fsmnkhrhg';

export const competitionsRequest = (competition_id = WC_ID) => {
  return axios.get(`/v1/competitions/${WC_ID}`);
};
